// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__37QDj","file":"styles_file__18ILK"};